// extracted by mini-css-extract-plugin
export default {"panel":"VOrZ4","withBackground":"dUiVI","panelActive":"yaazm","panelChecked":"_7GWxZ","checkmark":"cEuZd"};